<template>
    <v-touch
        tag="div"
        class="three-header"
        @pinch="invalidPinch($event)"
    >
        <div class="headerBody">
            <h1
                v-if="mode === 'compare'"
                class="mode"
            >
                3D軌跡 比較モード
            </h1>
            <h1
                v-else-if="mode === 'atBat'"
                class="mode"
            >
                3D軌跡 打席モード
            </h1>
            <div class="modeButtons">
                <v-touch
                    tag="p"
                    class="switchDisplay"
                    @tap="switchDisplayMode()"
                >
                    全画面表示
                </v-touch>
                <v-touch
                    v-if="mode !== 'atBat'"
                    tag="p"
                    @tap="changeMode('atBat')"
                >
                    3D軌跡 打席モード
                </v-touch>
                <v-touch
                    v-if="mode !== 'compare'"
                    tag="p"
                    @tap="changeMode('compare')"
                >
                    3D軌跡 比較モード
                </v-touch>
<!--                <v-touch-->
<!--                    v-if="mode !== 'tunnel'"-->
<!--                    tag="p"-->
<!--                    @tap="changeMode('tunnel')"-->
<!--                >-->
<!--                    トンネル-->
<!--                </v-touch>-->
            </div>
            <div class="closeModal">
                <p
                    v-if="['vsData','battingData','pitchingData','umpireData','he'].includes(currentState)"
                    @click="modal3dOff"
                >
                    ×
                </p>
                <p
                    v-else
                    @click="prevPage"
                >
                    ←
                </p>
            </div>
        </div>
    </v-touch>
</template>

<script>
import Common3dHeader from '@/components_common/3d/Header.vue'

export default {
    mixins: [Common3dHeader],
}
</script>

<style scoped>
.three-header {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
}

.headerBody {
    background: rgba(34, 34, 34, 0.75);
    width: 100%;
    height: 45px;
    position: relative;
}

h1.mode {
    font-size: 18px;
    line-height: 45px;
    color: #fff;
    font-weight: bold;
    text-align: center;
}

.modeButtons {
    position: absolute;
    top: 0;
    right: 0;
    padding: 10px 10px 0 0;
    display: flex;
}

.modeButtons p {
    margin-left: 5px;
    margin-right: 5px;
    color: #fff;
    border: solid 1px #fff;
    line-height: 23px;
    width: auto;
    padding: 0 5px;
    text-align: center;
    cursor: pointer;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}

.closeModal {
    position: absolute;
    top: 0;
    left: 0;
    padding: 10px 0 0 10px;
}

.closeModal p {
    color: #fff;
    line-height: 25px;
    font-size: 20px;
    cursor: pointer;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}

.switchDisplay {
    margin-right: 155px;
}
</style>
